export default "<div class=\"backBtn d-inline-block\" (click)=\"onClickLocal()\">\n  <img src=\"/assets/img/back@3x.png\" />\n</div>\n";